import { CustomizeControllerArgs } from '..';
import BaseEnrollPhoneFactorCustomizer from '../base';
import AuthenticatorEnrollmentDataCustomizer from './authenticator-enrollment-data';
import EnrollAuthenticatorCustomizer from './enroll-authenticator';

export default class EnrollPhoneFactorCustomizer extends BaseEnrollPhoneFactorCustomizer {
  private customizers: BaseEnrollPhoneFactorCustomizer[];
  constructor(args: CustomizeControllerArgs) {
    super(args);
    this.customizers = [ new AuthenticatorEnrollmentDataCustomizer(args), new EnrollAuthenticatorCustomizer(args) ];
  }
  async shouldCustomize() {
    let shouldCustomize = false;
    for (const customizer of this.customizers) {
      shouldCustomize = shouldCustomize || (await customizer.shouldCustomize());
    }
    return shouldCustomize;
  }

  async customize() {
    for (const customizer of this.customizers) {
      if (await customizer.shouldCustomize()) {
        await customizer.customize();
      }
    }
  }

}
